import React, { useEffect, useState, useRef } from "react";
import Webcam from "react-webcam";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import RoundButton from "../../../Common/RoundButton";
import { Field, Form, Formik } from "formik";
import { InputType } from "../../../Common/FormFields/InputType";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import ErrorMessage from "../../../Common/ErrorMessage";
const AdharCardForm = ({
  adharcardImage,
  handleRetake,
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  adharcardError
}: any) => {
  return (
    <>
      <div style={{ marginTop: "35px", marginBottom: "30px" }}>
        <img src={adharcardImage} />
      </div>
      <Typography className="fs-14">
        Make sure you place your Aadhar Card inside the frame as shown as above
      </Typography>

      <Box className="contentAreaPersonal">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(value) => onSubmitHandle(value)}
        >
          {({ handleSubmit, values, touched, errors }) => (
            <Form>
              <div style={{ marginTop: "20px" }}>
                <Field
                  component={InputType}
                  type="text"
                  placeholder="Enter your Aadhar Card no"
                  name="adharCard"
                  value={values.adharCard}
                  onChange={onChangeField}
                />
              </div>
              {
                adharcardError?.error && (
                  <ErrorMessage text={adharcardError?.error} />
                )
              }
              <div className="kyc-btn-view continue-white-btn">
                <RoundButton onClick={handleRetake} title={"Retake"} />
                <RoundButton type="submit" title={"Continue"} />
              </div>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default AdharCardForm;
